import React from 'react'
import { Container, makeStyles } from '@material-ui/core'
import BannerImg from '../../assets/banner.jpg';
import {Typography} from '@material-ui/core';
import Carousel from './Carousel';

const useStyles = makeStyles((theme)=>({
    banner:{
        backgroundImage: `url(${BannerImg})`,
    },
    content:{
        height: 400,
        display: "flex",
        flexDirection: "column",
        paddingTop: 25,
        justifyContent: "space-around",
    },
    tag:{
      justifyContent: "center",
      height: "40%",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
    },
    heading:{
      fontWeight: "bold",
      marginBottom: 15,
    },
    subhead:{
      color: "darkgrey",
      transform: "capitalize",
    },
}));

function Banner() {
  let classes = useStyles();
  return (
    <div className={classes.banner}>
        <Container className={classes.content}>
          <div className={classes.tag}>
            <Typography variant="h2" className={classes.heading}>
              Track the crypto
            </Typography>
            <Typography variant="subtitle2" className={classes.subhead}>
              App that keeps a track of crypto rankings
            </Typography>
          </div>
          <Carousel/>
        </Container>
    </div>
  )
}

export default Banner